import SEO from 'util/seo';
import React from 'react';
import { ContentWrapper } from 'components/organisms/contentWrapper';
import { headerHeightPc, mq } from 'style/variables';
import styled from '@emotion/styled';
import { graphql, useStaticQuery } from 'gatsby';
import { KeywordWall } from 'components/unique/career/keywordWall';
import { Positions } from 'components/unique/career/positions';
import { CareerFv } from 'components/unique/career/careerFv';
import { BeltImage } from 'components/unique/career/BeltImage';
import { BackgroundPatternWithLottie } from 'components/unique/career/backgroundPatternWithLottie';

const ParentWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

const SectionWrapper = styled.section`
  position: relative;
  z-index: 4;
  padding-top: ${headerHeightPc}px;
  ${mq.onlysp} {
    padding-top: 64px;
  }
`;

const Pages = () => {
  const careerList = useStaticQuery(graphql`
    query CareerDataTh {
      allKurocoCareerList {
        edges {
          node {
            topics_id
            subject
            slug
            order
            thumbnail {
              url
            }
            summary
            scope_desc1
            scope_desc2
            scope_outputs_label
            scope_outputs_image {
              url
              url_org
              desc
            }
            ideal_candidate {
              url
              url_org
              desc
            }
            skills_required
            skills_preferred
            tools_main
            tools_sub
            application_overview_label
            application_overview_content
          }
        }
      }
    }
  `);

  return (
    <>
      <SEO title={'Career'} />
      <ParentWrapper>
        <BackgroundPatternWithLottie />
        <SectionWrapper>
          <ContentWrapper noSpPadding>
            <CareerFv />
            <KeywordWall />
          </ContentWrapper>
        </SectionWrapper>
      </ParentWrapper>
      <BeltImage />
      <ContentWrapper noSpPadding>
        <Positions careerList={careerList.allKurocoCareerList.edges} />
      </ContentWrapper>
    </>
  );
};

export default Pages;
